import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'boma-print-footer',
  templateUrl: './boma-print-footer.component.html',
  styleUrls: ['./boma-print-footer.component.scss'],
})
export class BomaPrintFooterComponent implements OnInit {
  @Input() footerText = '';

  constructor() {}

  ngOnInit(): void {}
}
